<script setup lang="ts">
import { computed, toRef } from "vue";
import { useQueryClient } from "@tanstack/vue-query";
import { QueryKey } from "@/stores/queries/query-keys";
import { FileType } from "@/types/file.types";
import DRFilesUploaderDialog from "../UI/DRFilesUploaderDialog.vue";

const props = defineProps<{
  projectId: number;
  modelValue: boolean;
}>();

const emit = defineEmits<{
  (e: "update:modelValue", value: boolean): void;
}>();

const projectId = toRef(props, "projectId");

const show = computed({
  get: () => props.modelValue,
  set: (value: boolean) => {
    if (!value) {
      emit("update:modelValue", false);
    }
  },
});

const queryClient = useQueryClient();
const invalidateTemplates = () => {
  queryClient.invalidateQueries({ queryKey: [QueryKey.DIAGNOSTICS] });
};
</script>

<template>
  <DRFilesUploaderDialog
    v-model="show"
    :title="$t('report:diagnostics.prepare.inspection')"
    :helper="$t('report:import.report.project')"
    :file-type="FileType.DIAGNOSTIC_REPORT"
    :file-params="{
      projectId: projectId,
    }"
    multiple
    :upload-description="() => $t('report:diagnostics.accept.pdf.docx')"
    :extensions="['pdf', 'docx']"
    @uploaded="invalidateTemplates()"
  />
</template>
